import { Header } from "../../../components/header/Header"
import { FloorPlanImage, FloorPlanWrapper } from "./styles"
import LowerGroundFloor from './img/lower-ground-floor.jpg'
import UpperGroundFloor from './img/upper-ground-floor.jpg'
import FirstFloor from './img/first-floor.jpg'
import SecondFloor from './img/second-floor.jpg'
import ThirdFloor from './img/third-floor.jpg'
import ForthFloor from './img/forth-floor.jpg'

export const FloorPlan = () => {

    const images = [
        {
            title: 'Lower Ground Floor',
            img: LowerGroundFloor
        },
        {
            title: 'Upper Ground Floor',
            img: UpperGroundFloor
        },
        {
            title: 'First Floor',
            img: FirstFloor
        },
        {
            title: 'Second Floor',
            img: SecondFloor
        },
        {
            title: 'Third Floor',
            img: ThirdFloor
        },
        {
            title: 'Forth Floor',
            img: ForthFloor
        },
    ]
    return (
        <FloorPlanWrapper>
            <Header>Celeste Mall & Multiplex - Floor Plans</Header>
            {
                images.map((item, index) => (
                    <FloorPlanImage key={index} src={item.img} alt={item.title} />
                ))
            }
        </FloorPlanWrapper>
    )
}